import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./navbar.scss";
import { GiHamburgerMenu } from "react-icons/gi";

export const Navbar = () => {
  const [openNav, setOpenNav] = useState(false);

  return (
    <nav className="navbar navbar-expand-lg navbar-transparent bg-transparent fixed-top">
      <div className="container-fluid">
        <i className="navbar-brand">luispimentel.c</i>
        <button
          onClick={() => setOpenNav(!openNav)}
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <GiHamburgerMenu />
        </button>
      </div>
      <div
        className={
          openNav
            ? "navbar-collapse collapse active"
            : "navbar-collapse collapse"
        }
        id="navbarSupportedContent"
      >
        <ul className="navbar-nav me-auto">
          {navItems.map((item: NavItem, i: number) => (
            <li key={i} className="nav-item">
              <Link
                key={i}
                className="nav-link"
                to={
                  item.hash!.length > 0
                    ? { hash: item.hash }
                    : { pathname: item.href }
                }
              >
                {item.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

type NavItem = {
  title: string;
  href?: string;
  hash?: string;
};

const navItems: NavItem[] = [
  {
    title: "About",
    hash: "#about",
  },
  {
    title: "Service",
    hash: "#service",
  },
  {
    title: "Experience",
    hash: "#experience",
  },
  {
    title: "Portfolio",
    href: "/portfolio",
    hash: "",
  },
  {
    title: "Contacts",
    href: "",
    hash: "#contacts",
  },
];
